import { SIDE_NAV_WIDTH } from '../side-nav/nav-items'

export const APP_HEADER_HEIGHT = 56

const styles = () => ({
  // Fixed for the same reason as the side nav (see side-nav/styles.js).
  root: {
    position: 'fixed',
    top: 0,
    left: SIDE_NAV_WIDTH,
    right: 0,
    zIndex: 1100,
    height: APP_HEADER_HEIGHT,
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '0 40px',
    background: '#FFFFFF',
    borderBottom: '1px solid #E5E7EB',
  },
  right: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  // Trial: days left and Upgrade now, as in the old top bar.
  trialText: {
    fontFamily: "'Inter', system-ui, sans-serif",
    fontSize: '13px',
    fontWeight: 500,
    color: '#002E47',
    whiteSpace: 'nowrap',
  },
  upgrade: {
    display: 'inline-flex',
    alignItems: 'center',
    height: 30,
    padding: '0 12px',
    borderRadius: '6px',
    background: '#FB9D01',
    color: '#FFFFFF',
    fontFamily: "'Inter', system-ui, sans-serif",
    fontSize: '13px',
    fontWeight: 500,
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      background: '#E08C00',
    },
  },
  divider: {
    width: 1,
    height: 24,
    background: '#E5E7EB',
  },
  credits: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: "'Inter', system-ui, sans-serif",
    fontSize: '13px',
    fontWeight: 500,
    color: '#015FFB',
  },
  creditsIcon: {
    width: 16,
    height: 16,
    flex: 'none',
  },
})

export default styles
